import type { ComponentType, ElementType } from 'react';
import type { Profile } from './profile';

export type ArticleType = 'getting-started' | 'screen' | 'task' | 'flow' | 'concept' | 'faq';
export type ArticleStatus = 'draft' | 'published' | 'archived';

export const ARTICLE_TYPE_LABEL: Record<ArticleType, string> = {
  'getting-started': 'Comece aqui',
  screen: 'Conheça a tela',
  task: 'Passo a passo',
  flow: 'Fluxo',
  concept: 'Conceito',
  faq: 'Pergunta frequente',
};

export interface ArticleMeta {
  id: string;
  slug: string;
  title: string;
  description: string;
  profile: Profile;
  category: string;
  type: ArticleType;
  status: ArticleStatus;
  order: number;
  keywords: string[];
  previous?: string;
  next?: string;
  related?: string[];
  screenshots?: string[];
  updatedAt: string;
  appVersion: string;
}

export interface MDXContentProps {
  components?: Record<string, ElementType>;
}

export interface ArticleModule {
  default: ComponentType<MDXContentProps>;
  meta: ArticleMeta;
}
